<template>
    <div v-if="user" class="panel__container panel__container--small">
        <header class="panel__header">
            <h2 class="panel__title">{{ user.display_name }}</h2>
        </header>
        <form @submit.prevent="save()" class="form">
            <div class="form__wrapper">
                <div class="form__column w-full md:w-2/3">
                    <div class="form__group" :class="{ 'form__group--error' : form.errors.has('channels')}">
                        <label class="form__label">Channels</label>
                        <label :key="channel.id" v-for="channel in activeChannels" class="form__label">
                            <input type="checkbox" v-model="form.channels" :value="channel.id">
                            {{ channel.name }}
                        </label>
                        <p v-if="form.errors.has('channels')" class="form__help form__help--error">{{ form.errors.get('channels') }}</p>
                    </div>
                </div>
                <div class="form__column  w-full md:w-1/3">
                    <div class="form__group" :class="{ 'form__group--error' : form.errors.has('role')}">
                        <label class="form__label">Role</label>
                        <simple-dropdown class="form__dropdown" v-model="form.role" ref="dropdown" :options="roles">Role</simple-dropdown>
                        <p v-if="form.errors.has('role')" class="form__help form__help--error">{{ form.errors.get('role') }}</p>
                    </div>
                </div>
                <div class="form__footer w-full form__footer--right">
                    <router-link to="/people" class="mr-10">Cancel</router-link>
                    <button type="submit" class="lc-submit button button--primary button--small" :disabled="form.busy">Save</button>
                </div>
            </div>
        </form>
    </div>
    <div v-else></div>
</template>
<script>
/* global app, EventBus */
import { mapState, mapGetters } from 'vuex'
import SimpleDropdown from '../../../components/Global/SimpleDropdown'
import Form from '../../../helpers/Form'

export default {
    data () {
        return {
            form: new Form({
                role: '',
                channels: []
            }),
            roles: app.config.USER_ROLES
        }
    },

    mounted () {
        if (this.user) {
            this.form.role = this.user.role
            this.form.channels = this.user.channels.map(channel => channel.id)
        } else {
            EventBus.$emit('newSnackbar', 'User not found')
            this.$router.replace({ path: '/people' })
        }
    },

    methods: {
        save () {
            let data = {
                userId: this.user.id,
                form: this.form
            }

            this.$store.dispatch('tenant/updateUser', data).then(() => {
                EventBus.$emit('newSnackbar', `${this.user.display_name} was updated`)
                this.$router.push({ path: '/people' })
            })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('tenant', ['users']),

        ...mapGetters(['activeChannels']),

        user () {
            return this.users.find(user => user.id === parseInt(this.$route.params.user))
        }
    },

    components: {
        SimpleDropdown
    }
}
</script>
